import React, { useReducer } from 'react';
import ChartContext from './chartContext';
import ChartReducer from './chartReducer';
import api from '../../api/api';
import {
    LOADING_MONITORING_AGENTS,
    GET_ADDONS_REPORT,
    GET_STORES_SCORES_TABLE,
    GET_STORES_EXTRA_SCORES_TABLE,
    GET_CAPTACION_MEDIOS,
    GET_REPORT_SALES,
    GET_REPORT_RESPONSE_TIME,
    GET_MONITORING_AGENT_SOURCES,
    GET_VISITS_SUBSTATUS_CHART,
    GET_MONITORING_AGENT,
    GET_APPOINTMENTS_BY_STORE_CHART,
    GET_VISITS_BY_STORE_CHART,
    GET_SOLDS_BY_STORE_CHART,
    GET_HOURS_CHART,
    GET_AGENTS_COMPARATIVE,
    GET_TOTALS_DASHBOARD,
    GET_TEMPERATURES_LEADS_TABLE,
    GET_TEMPERATURES_APPOINTMENTS_TABLE,
    GET_TEMPERATURES_VISITS_TABLE,
    GET_TEMPERATURES_SALES_TABLE,
    CLEAR_STATE,
    GET_TABLE_AGENT_SOURCES,
    SET_LOADING,
    GET_LEADS_MONTHLY_CHART,
    GET_LEADS_STORE_CHART,
    GET_PROFIT_CHART,
    GET_TOTALS_FINANCING_DASHBOARD,
    GET_TOTALS_VISITS_DASHBOARD,
    GET_PROFIT_STORE_CHART,
    GET_PROFIT_MODEL_CHART,
    GET_OPERATION_TYPE_CHART,
    GET_FINANCIAL_INSTITUTION_CHART,
    GET_INVESTMENT_PROFIT_STORE_CHART,
    GET_TABLE_AGENCIES,
    GET_TOTALS_INVESTMENT_DASHBOARD,
    GET_AGENTS_LEADS_TABLE,
    GET_AGENTS_CALLS_TABLE,
    GET_AGENTS_SOLDS_TABLE,
    GET_AGENTS_VISITS_TABLE,
    GET_AGENTS_APPOINTMENTS_TABLE,
    GET_TEMPERATURES_CHART,
    GET_WEEKLY_PROFIT_CHART,
    GET_TEMPERATURES_FUNNEL,
    GET_TEMPERATURES_FUNNEL_RSI,
    GET_TEMPERATURES_FUNNEL_RSI_COMPARATIVE,
    GET_STATUS_REPORT_CHART,
    GET_SUBSTATUS_AGENT_CHART,
    GET_APPOINTMENTS_SUBSTATUS_CHART,
    GET_VISITS_DETAILS_CHART,
    GET_APPOINTMENTS_STORES_CHART,
    GET_APPOINTMENTS_DETAILS_CHART,
    GET_TOTALS_CALLS_DASHBOARD,
    GET_CLOSURE_TOP_USERS,
    GET_CALLS_DRILLDOWN_CHART,
    GET_AGENTS_CALLS_CHART,
    GET_STATUS_STORES_CHART,
    GET_UNIT_MONTHLY_COMPARATIVE_CHART,
    GET_TOTAL_TEMPERATURES,
    GET_FUNNEL_APPOINTMENT_CHART,
    GET_TEMPERATURES_FUNNEL_APPOINTMENT_COMPARATIVE,
    GET_FUNNEL_DATOS,
    GET_DRILLDOWN_FUNNEL_SOURCE,
    GET_RECORDINGS_DRILLDOWN_CHART,
    GET_PENDING_TASKS,
    GET_REPORT_VISITS,
    GET_MATRIX_INVESTMENT,
    GET_TABLE_SOURCES,
    GET_TABLEMODELS,
    GET_TABLELEADSBYAGENTS,
    GET_MATRIX_INVESTMENT_CAMPAIGN,
    GET_MATRIX_INVESTMENT_ADSET,
    GET_INVESTMENTS,
    CREATE_INVESTMENT,
    DELETE_INVESTMENT,
    GET_INVESTMENT,
    UPDATE_INVESTMENT,
    GET_DRILLDOWN_PENDING_LEADS_CHART,
    POST_CUSTOM_CHART,
    GET_AGENTS_CALLS_PERFORMANCE,
    GET_MULTIPLE_COMPARATIVE_CHART,
    GET_AI_REPORT,
    GET_WARBOX_TEMPLATE_METRICS,
    GET_SYSTEM_REPORT,
} from '../types';
import { HEADERS } from '../../constants/headers';
import { STORE_AREA } from '../../constants/store/areas';
import { DEFAULT_CHART_STATE } from './constants/defaultChartState';
import { ApiV2 } from 'src/api/apiv2';
import { getDocumentId } from 'src/utils/mongo/getDocumentId';
import { FIRST_PAGE } from 'src/views/chartLeads/UserCallPerformance/constants/AccordionList';
import { handleError } from '../utils/handleError';
import { fetchDashboardChart } from 'src/api/fetchDashboardChart';

const ChartState = (props) => {
    const [state, dispatch] = useReducer(ChartReducer, DEFAULT_CHART_STATE);

    const getAgentsCallsPerformance = async (query) => {
        query.page == FIRST_PAGE && setLoading();
        try {
            const filteredParams = Object.entries(query)
                .filter(([key, value]) => value !== null && value !== undefined)
                .reduce((acc, [key, value]) => {
                    if (key === STORE_AREA) {
                        return {
                            ...acc,
                            [key]: Array.isArray(value) ? value : [value],
                        };
                    } else {
                        return { ...acc, [key]: value };
                    }
                }, {});
            const res = await api.post(
                `/charts/agentsCallsPerformance`,
                filteredParams,
                HEADERS()
            );
            dispatch({
                type: GET_AGENTS_CALLS_PERFORMANCE,
                payload: res.data.data.results,
                pagination: res.data.data.pagination,
                isLoadMore: query.page > FIRST_PAGE,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getTableLeadsByAgents = async (initialQuery) => {
        setLoading();
        try {
            const res = await api.post(
                `/charts/tableLeadsByAgents`,
                initialQuery,
                HEADERS()
            );
            dispatch({ type: GET_TABLELEADSBYAGENTS, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getTableModels = async (initialQuery) => {
        setLoading();
        try {
            const res = await api.post(
                `/charts/tableModels`,
                initialQuery,
                HEADERS()
            );
            dispatch({ type: GET_TABLEMODELS, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getAIReport = async (initialQuery) => {
        setLoading();
        try {
            const res = await api.post(
                `/charts/AIReport`,
                initialQuery,
                HEADERS()
            );
            dispatch({ type: GET_AI_REPORT, payload: res.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getWarboxTemplateMetrics = async (initialQuery) => {
        setLoading();
        try {
            const res = await api.post(
                `/charts/warboxTemplateMetrics`,
                initialQuery,
                HEADERS()
            );
            dispatch({
                type: GET_WARBOX_TEMPLATE_METRICS,
                payload: {
                    categories: res.data?.categories || [],
                    data: res.data?.data || [],
                },
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getSystemReport = async (initialQuery) => {
        setLoading();
        try {
            const res = await api.post(
                `/charts/systemReport`,
                initialQuery,
                HEADERS()
            );
            dispatch({ type: GET_SYSTEM_REPORT, payload: res.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getTableSources = async (initialQuery) => {
        setLoading();
        try {
            const res = await api.post(
                `/charts/tableSources`,
                initialQuery,
                HEADERS()
            );
            dispatch({ type: GET_TABLE_SOURCES, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getTableAgencies = async (initialQuery) => {
        setLoading();
        try {
            const res = await api.post(
                `/charts/tableAgencies`,
                initialQuery,
                HEADERS()
            );
            dispatch({ type: GET_TABLE_AGENCIES, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getPendingTasksReport = async (values) => {
        setLoading();
        try {
            const res = await api.post(
                `/charts/pendingTasksReport`,
                { ...values },
                HEADERS()
            );
            dispatch({ type: GET_PENDING_TASKS, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getMonitoringAgent = async (query) => {
        setLoading(LOADING_MONITORING_AGENTS);
        try {
            const res = await api.get(
                `/charts/monitoringAgent?${query}`,
                HEADERS()
            );
            dispatch({ type: GET_MONITORING_AGENT, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getMonitoringAgentSources = async (query) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/monitoringAgentSources?${query}`,
                HEADERS()
            );
            dispatch({
                type: GET_MONITORING_AGENT_SOURCES,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getTemperaturesLeadsTable = async (query) => {
        // setLoading();
        try {
            const res = await api.get(
                `/charts/temperaturesLeadsTable?${query}`,
                HEADERS()
            );
            dispatch({
                type: GET_TEMPERATURES_LEADS_TABLE,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getTemperaturesAppointmentsTable = async (query) => {
        // setLoading();
        try {
            const res = await api.get(
                `/charts/temperaturesAppointmentsTable?${query}`,
                HEADERS()
            );
            dispatch({
                type: GET_TEMPERATURES_APPOINTMENTS_TABLE,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getTemperaturesVisitsTable = async (query) => {
        // setLoading();
        try {
            const res = await api.get(
                `/charts/temperaturesVisitsTable?${query}`,
                HEADERS()
            );
            dispatch({
                type: GET_TEMPERATURES_VISITS_TABLE,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getTemperaturesSalesTable = async (query) => {
        // setLoading();
        try {
            const res = await api.get(
                `/charts/temperaturesSalesTable?${query}`,
                HEADERS()
            );
            dispatch({
                type: GET_TEMPERATURES_SALES_TABLE,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getClosureTopUsers = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(
                `/charts/closureTopUsers`,
                { ...values }
            );
            dispatch({ type: GET_CLOSURE_TOP_USERS, payload: res.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getAppointmentsSubstatusChart = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(
                `/charts/appointmentsSubstatusChart`,
                { ...values }
            );
            dispatch({
                type: GET_APPOINTMENTS_SUBSTATUS_CHART,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getAppointmentsStoresChart = async (query) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/appointmentsStoresChart?${query}`,
                HEADERS()
            );
            dispatch({
                type: GET_APPOINTMENTS_STORES_CHART,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getAppointmentsDetailsChart = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(
                `/charts/appointmentsDetailsChart`,
                { ...values }
            );
            dispatch({
                type: GET_APPOINTMENTS_DETAILS_CHART,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getSubstatusAgentChart = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(
                `/charts/substatusAgentChart`,
                { ...values }
            );
            dispatch({
                type: GET_SUBSTATUS_AGENT_CHART,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Substatus Report
    const getStatusStoresChart = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(
                `/charts/statusStoresChart`,
                { ...values }
            );
            dispatch({ type: GET_STATUS_STORES_CHART, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Status Report
    const getStatusReportChart = async (query) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/statusReportChart?${query}`,
                HEADERS()
            );
            dispatch({ type: GET_STATUS_REPORT_CHART, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Temperatures Chart
    const getTemperaturesFunnel = async (query) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/temperaturesFunnel?${query}`,
                HEADERS()
            );
            dispatch({ type: GET_TEMPERATURES_FUNNEL, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Temperatures Chart
    const getTemperaturesFunnelRSI = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(
                `/charts/temperaturesFunnelRSI`,
                { ...values }
            );
            dispatch({
                type: GET_TEMPERATURES_FUNNEL_RSI,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getFunnelAppointment = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(
                `/charts/funnelAppointment`,
                { ...values }
            );
            dispatch({
                type: GET_FUNNEL_APPOINTMENT_CHART,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getFunnelDatos = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(
                `/charts/funnelDatos`,
                { ...values }
            );
            dispatch({ type: GET_FUNNEL_DATOS, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Temperatures Chart
    const getTemperaturesFunnelAppointmentComparative = async (
        query,
        position
    ) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/funnelAppointment?${query}`,
                HEADERS()
            );
            dispatch({
                type: GET_TEMPERATURES_FUNNEL_APPOINTMENT_COMPARATIVE,
                payload: res.data.data,
                position,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Temperatures Chart
    const getTemperaturesFunnelRSIComparative = async (query, position) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/temperaturesFunnelRSI?${query}`,
                HEADERS()
            );
            dispatch({
                type: GET_TEMPERATURES_FUNNEL_RSI_COMPARATIVE,
                payload: res.data.data,
                position,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Temperatures Chart
    const getTotalTemperatures = async (query) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/totalTemperatures?${query}`,
                HEADERS()
            );
            dispatch({ type: GET_TOTAL_TEMPERATURES, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getMultipleComparativeChart = async (query) => {
        setLoading();

        try {
            const res = await api.post(
                `/charts/multipleComparativeChart`,
                query,
                HEADERS()
            );
            dispatch({
                type: GET_MULTIPLE_COMPARATIVE_CHART,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getUnitComparativeChartGrouped = async (query, data) => {
        setLoading();
        try {
            const res = await api.post(
                `/charts/unitComparativeChartGrouped?${query}`,
                data,
                HEADERS()
            );
            dispatch({
                type: GET_UNIT_MONTHLY_COMPARATIVE_CHART,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Temperatures Chart
    const getTemperaturesChart = async (endpoint, query) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/globalSumary?${query}${endpoint}`,
                HEADERS()
            );
            dispatch({ type: GET_TEMPERATURES_CHART, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get global sources Chart
    const getCaptacionMedios = async (query) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/captacionMedios?${query}`,
                HEADERS()
            );
            dispatch({ type: GET_CAPTACION_MEDIOS, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Agents - Substatus Sold Table
    const getAgentsSoldsTable = async (query) => {
        // setLoading();
        try {
            const res = await api.get(
                `/charts/agentsSoldsTable?${query}`,
                HEADERS()
            );
            dispatch({ type: GET_AGENTS_SOLDS_TABLE, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Agents - Substatus Visit Table
    const getAgentsVisitsTable = async (query) => {
        // setLoading();
        try {
            const res = await api.get(
                `/charts/agentsVisitsTable?${query}`,
                HEADERS()
            );
            dispatch({ type: GET_AGENTS_VISITS_TABLE, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getAgentsCallsChart = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(
                `/charts/agentsCallsChart`,
                { ...values }
            );
            dispatch({ type: GET_AGENTS_CALLS_CHART, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Agents - Substatus Visit Table
    const getAgentsCallsTable = async (query) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/agentsCallsTable?${query}`,
                HEADERS()
            );
            dispatch({ type: GET_AGENTS_CALLS_TABLE, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getStoresExtraScoresTable = async (query) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/storesExtraScoresTable?${query}`,
                HEADERS()
            );
            dispatch({
                type: GET_STORES_EXTRA_SCORES_TABLE,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getStoresScoresTable = async (values) => {
        setLoading();
        try {
            const res = await api.post(
                `/charts/storesScoresTable`,
                { ...values },
                HEADERS()
            );
            dispatch({ type: GET_STORES_SCORES_TABLE, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Agents - Substatus Visit Table
    const getVisitsReport = async (values) => {
        setLoading();
        try {
            const res = await api.post(
                `/charts/reportVisits`,
                { ...values },
                HEADERS()
            );
            dispatch({ type: GET_REPORT_VISITS, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Agents - Substatus Appointment Table
    const getAgentsAppointmentsTable = async (query) => {
        // setLoading();
        try {
            const res = await api.get(
                `/charts/agentsAppointmentsTable?${query}`,
                HEADERS()
            );
            dispatch({
                type: GET_AGENTS_APPOINTMENTS_TABLE,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Agents - Substatus Lead Table
    const getAgentsLeadsTable = async (query) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/agentsLeadsTable?${query}`,
                HEADERS()
            );
            dispatch({ type: GET_AGENTS_LEADS_TABLE, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Agents - Substatus Lead Table
    const getAgentsComparative = async (query) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/agentsComparative?${query}`,
                HEADERS()
            );
            dispatch({ type: GET_AGENTS_COMPARATIVE, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getAddonsReport = async (values) => {
        setLoading();
        try {
            const res = await ApiV2.post(
                `/reports/addonsReport`,
                { ...values },
                HEADERS()
            );
            dispatch({ type: GET_ADDONS_REPORT, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getTableAgentSources = async (query) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/agentsSourcesComparative?${query}`,
                HEADERS()
            );
            dispatch({ type: GET_TABLE_AGENT_SOURCES, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Financial Chart
    const getFinancialInstitutionChart = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(
                `/charts/financialInstitutionChart`,
                { ...values }
            );
            dispatch({
                type: GET_FINANCIAL_INSTITUTION_CHART,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getOperationTypeChart = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(
                `/charts/operationTypeChart`,
                { ...values }
            );
            dispatch({
                type: GET_OPERATION_TYPE_CHART,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getProfitModelChart = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(
                `/charts/profitModelChart`,
                { ...values }
            );
            dispatch({ type: GET_PROFIT_MODEL_CHART, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getProfitStoreChart = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(
                `/charts/profitStoreChart`,
                { ...values }
            );
            dispatch({ type: GET_PROFIT_STORE_CHART, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Profit Chart
    const getInvestmentProfitStoreChart = async (query) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/investmentProfitStoreChart?${query}`,
                HEADERS()
            );
            dispatch({
                type: GET_INVESTMENT_PROFIT_STORE_CHART,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Profit Chart
    const getTotalsInvestmentDashboard = async (query) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/totalsInvestmentDashboard?${query}`,
                HEADERS()
            );
            dispatch({
                type: GET_TOTALS_INVESTMENT_DASHBOARD,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getTotalsFinancingDashboard = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(
                `/charts/totalsFinancingDashboard`,
                { ...values }
            );
            dispatch({
                type: GET_TOTALS_FINANCING_DASHBOARD,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    // ? visit charts dash
    const getTotalsVisitsDashboard = async (query) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/totalsVisitsDashboard?${query}`,
                HEADERS()
            );
            dispatch({
                type: GET_TOTALS_VISITS_DASHBOARD,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getVisitsSubstatusChart = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(
                `/charts/visitsSubstatusChart`,
                { ...values }
            );
            dispatch({
                type: GET_VISITS_SUBSTATUS_CHART,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getVisitsDetailsChart = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(
                `/charts/visitsDetailsChart`,
                { ...values }
            );
            dispatch({
                type: GET_VISITS_DETAILS_CHART,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    // ? calls charts dash
    const getTotalsCallsDashboard = async (query) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/totalsCallsDashboard?${query}`,
                HEADERS()
            );
            dispatch({
                type: GET_TOTALS_CALLS_DASHBOARD,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getDrilldownCalls = async (endpoint, query) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/${endpoint}?${query}`,
                HEADERS()
            );
            dispatch({
                type: GET_CALLS_DRILLDOWN_CHART,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getDrilldownPendingLeads = async (query) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/drilldownPendingLeads?${query}`,
                HEADERS()
            );
            dispatch({
                type: GET_DRILLDOWN_PENDING_LEADS_CHART,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getDrilldownRecordings = async (query) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/drilldownRecordings?${query}`,
                HEADERS()
            );
            dispatch({
                type: GET_RECORDINGS_DRILLDOWN_CHART,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getDrilldownFunnelSource = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(
                `/charts/drilldownFunnelSource`,
                { ...values }
            );
            dispatch({
                type: GET_DRILLDOWN_FUNNEL_SOURCE,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Profit Chart
    const getProfitChart = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(`/charts/profitChart`, {
                ...values,
            });
            dispatch({ type: GET_PROFIT_CHART, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Profit Chart
    const getWeeklyProfitChart = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(
                `/charts/weeklyProfitChart`,
                { ...values }
            );
            dispatch({ type: GET_WEEKLY_PROFIT_CHART, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const getLeadsMonthlyChart = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(
                `/charts/leadsMonthlyChart`,
                { ...values, detail: true }
            );
            dispatch({ type: GET_LEADS_MONTHLY_CHART, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Leads by Store Chart
    const getLeadsStoreChart = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(`/charts/leadsStoreChart`, {
                ...values,
            });
            dispatch({ type: GET_LEADS_STORE_CHART, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Totals Dashboard
    const getTotalsDashboard = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(
                `/charts/getTotalsDashboard`,
                { ...values }
            );
            dispatch({ type: GET_TOTALS_DASHBOARD, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Models Chart
    const getHoursChart = async (query) => {
        setLoading();
        try {
            const res = await api.get(`/charts/hoursChart?${query}`, HEADERS());
            dispatch({ type: GET_HOURS_CHART, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Total Appointments
    const getAppointmentsByStore = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(
                '/charts/statusAppointmentChart',
                { ...values }
            );
            dispatch({
                type: GET_APPOINTMENTS_BY_STORE_CHART,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Total Visits
    const getVisitsByStore = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(
                `/charts/statusVisitChart`,
                { ...values }
            );
            dispatch({
                type: GET_VISITS_BY_STORE_CHART,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Total Solds
    const getSoldsByStore = async (values) => {
        setLoading();
        try {
            const res = await fetchDashboardChart(`/charts/statusSoldChart`, {
                ...values,
            });
            dispatch({
                type: GET_SOLDS_BY_STORE_CHART,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get report sales
    const getReportSales = async (query) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/reportSales?${query}`,
                HEADERS()
            );
            dispatch({ type: GET_REPORT_SALES, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get report response time
    const getReportResponseTime = async (query) => {
        setLoading();
        try {
            const res = await api.get(
                `/charts/reportResponseTime?${query}`,
                HEADERS()
            );
            dispatch({
                type: GET_REPORT_RESPONSE_TIME,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Matrix
    const getMatrixInvestment = async (values) => {
        try {
            let query = { ...values };

            if (values.source) {
                query.source = null;
                query.source__id = getDocumentId(values.source);
            }

            setLoading();
            const res = await api.post(
                `/investmentsChart/drilldown`,
                query,
                HEADERS()
            );
            dispatch({ type: GET_MATRIX_INVESTMENT, payload: res.data.data });
        } catch (error) {
            dispatchandleError(error);
        }
    };

    //Get Matrix
    const getMatrixInvestmentCampaign = async (values) => {
        try {
            setLoading();
            const res = await api.post(
                `/charts/matrixInvestment/campaign`,
                { ...values },
                HEADERS()
            );
            dispatch({
                type: GET_MATRIX_INVESTMENT_CAMPAIGN,
                payload: res.data.data,
            });
        } catch (error) {
            dispatchandleError(error);
        }
    };

    //Get Matrix
    const getMatrixInvestmentAdset = async (values) => {
        try {
            setLoading();
            const res = await api.post(
                `/charts/matrixInvestment/adsets`,
                { ...values },
                HEADERS()
            );
            dispatch({
                type: GET_MATRIX_INVESTMENT_ADSET,
                payload: res.data.data,
            });
        } catch (error) {
            dispatchandleError(error);
        }
    };

    //Clear State
    const clearCharts = () => dispatch({ type: CLEAR_STATE });

    //Set Loading
    const setLoading = (loadingName = '') => {
        if (loadingName) dispatch({ type: loadingName });
        else dispatch({ type: SET_LOADING });
    };

    //Funciones para la grafica pendeja
    const getInvestmentChartList = async (values) => {
        setLoading();
        try {
            const res = await api.post(
                `/investmentsChart/investmentAR`,
                { ...values },
                HEADERS()
            );

            dispatch({
                type: GET_INVESTMENTS,
                payload: res.data.data,
                count: res.data.pagination.total,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Create Investment
    const createInvestment = async (investment, file) => {
        setLoading();

        try {
            const res = await api.post(
                `/investmentsChart`,
                { ...investment },
                HEADERS()
            );
            dispatch({ type: CREATE_INVESTMENT, payload: res.data.data });
        } catch (error) {
            dispatchandleError(error);
        }
    };

    //Delete Investment
    const deleteInvestment = async (investmentId) => {
        setLoading();
        try {
            const res = await api.delete(
                `/investmentsChart/${investmentId}`,
                HEADERS()
            );
            dispatch({ type: DELETE_INVESTMENT, payload: res.data.deletedId });
        } catch (error) {
            dispatchandleError(error);
        }
    };

    //Update Investment
    const updateInvestment = async (investment, investmentId, file) => {
        clearCharts();
        setLoading();

        try {
            let res = await api.put(
                `/investmentsChart/${investmentId}`,
                { ...investment },
                HEADERS()
            );
            dispatch({ type: UPDATE_INVESTMENT, payload: res.data.data });
        } catch (error) {
            dispatchandleError(error);
        }
    };

    //Get Investment
    const getInvestment = async (investmentId) => {
        clearCharts();
        setLoading();
        try {
            const res = await api.get(
                `/investmentsChart/${investmentId}`,
                HEADERS()
            );
            dispatch({ type: GET_INVESTMENT, payload: res.data.data });
        } catch (error) {
            dispatchandleError(error);
        }
    };

    /**
     * Posts a custom chart data to the server.
     *
     * @param {object} options - The options for posting the custom chart.
     * @param {object} options.query - The query parameters for the chart.
     * @param {string} options.chartName - The name of the chart.
     * @param {string} [options.stateName] - The name of the state to update (optional, defaults to chartName).
     * @param {boolean} [options.dissableLoading] - Indicates whether loading state should be set (optional).
     */
    const postCustomChart = async ({
        query,
        chartName,
        stateName,
        dissableLoading,
    }) => {
        if (!dissableLoading) setLoading();
        try {
            const res = await api.post(
                `/charts/${chartName}`,
                { ...query },
                HEADERS()
            );
            dispatch({
                type: POST_CUSTOM_CHART,
                payload: res.data.data,
                stateName: stateName || chartName,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    return (
        <ChartContext.Provider
            value={{
                ...state,
                getMultipleComparativeChart,
                multipleComparativeChart: state.multipleComparativeChart,
                postCustomChart,
                getDrilldownPendingLeads,
                drilldownPendingLeads: state.drilldownPendingLeads,
                getInvestmentChartList,
                createInvestment,
                deleteInvestment,
                updateInvestment,
                getInvestment,
                investments: state.investments,
                investment: state.investment,
                count: state.count,

                loadingCharts: state.loadingCharts,
                error: state.error,
                appointmentsByStore: state.appointmentsByStore,
                visitsByStore: state.visitsByStore,
                soldsByStore: state.soldsByStore,

                getAppointmentsByStore,
                getVisitsByStore,
                getSoldsByStore,

                monthly: state.monthly,

                getHoursChart,
                hours: state.hours,

                pieStatus: state.pieStatus,

                getTotalsDashboard,
                totalLeads: state.totalLeads,
                totalVisits: state.totalVisits,
                totalAppointments: state.totalAppointments,
                totalSolds: state.totalSolds,
                goals: state.goals,
                goalsPeriodMonths: state.goalsPeriodMonths,
                total: state.total,
                totalNew: state.totalNew,
                totalFollowUp: state.totalFollowUp,
                totalCallAgain: state.totalCallAgain,
                totalWrongnumber: state.totalWrongnumber,
                totalRejected: state.totalRejected,
                totalDocumentation: state.totalDocumentation,
                totalConfirm: state.totalConfirm,
                totalConfirmed: state.totalConfirmed,
                totalVisitTracking: state.totalVisitTracking,
                totalReschedule: state.totalReschedule,
                totalClientNa: state.totalClientNa,
                totalVisited: state.totalVisited,
                totalApplication: state.totalApplication,
                totalApprovedApplication: state.totalApprovedApplication,
                totalCondicionedApplication: state.totalCondicionedApplication,
                totalRejectedApplication: state.totalRejectedApplication,
                totalSeparation: state.totalSeparation,

                getLeadsMonthlyChart,
                leadsMonthlyChart: state.leadsMonthlyChart,

                getLeadsStoreChart,
                leadsStoreChart: state.leadsStoreChart,

                getProfitChart,
                profitChart: state.profitChart,

                getWeeklyProfitChart,
                weeklyProfitChart: state.weeklyProfitChart,

                getTotalsFinancingDashboard,
                totalFinancing: state.totalFinancing,
                totalProfits: state.totalProfits,

                getTotalsInvestmentDashboard,
                totalInvestment: state.totalInvestment,
                totalProfitsInvestment: state.totalProfitsInvestment,

                getProfitStoreChart,
                profitStoreChart: state.profitStoreChart,

                getInvestmentProfitStoreChart,
                investmentProfitStoreChart: state.investmentProfitStoreChart,

                getProfitModelChart,
                profitModelChart: state.profitModelChart,

                getOperationTypeChart,
                operationTypeChart: state.operationTypeChart,

                getFinancialInstitutionChart,
                financialInstitutionChart: state.financialInstitutionChart,

                getAgentsLeadsTable,
                agentsLeadsTable: state.agentsLeadsTable,

                getAgentsVisitsTable,
                agentsVisitsTable: state.agentsVisitsTable,

                getAgentsCallsChart,
                agentsCallsChart: state.agentsCallsChart,

                getAgentsCallsTable,
                agentsCallsTable: state.agentsCallsTable,

                getStoresExtraScoresTable,
                storesExtraScoresTable: state.storesExtraScoresTable,

                getStoresScoresTable,
                storesScoresTable: state.storesScoresTable,

                getAgentsAppointmentsTable,
                agentsAppointmentsTable: state.agentsAppointmentsTable,

                getAgentsSoldsTable,
                agentsSoldsTable: state.agentsSoldsTable,

                getTemperaturesChart,
                temperaturesChart: state.temperaturesChart,

                getUnitComparativeChartGrouped,
                unitMonthlyComparativeChart: state.unitMonthlyComparativeChart,

                getTemperaturesFunnel,
                temperaturesFunnel: state.temperaturesFunnel,

                getTemperaturesFunnelRSI,
                temperaturesFunnelRSI: state.temperaturesFunnelRSI,

                getFunnelAppointment,
                funnelAppointment: state.funnelAppointment,

                getStatusReportChart,
                statusReportChart: state.statusReportChart,

                getSubstatusAgentChart,
                substatusAgentChart: state.substatusAgentChart,

                getAppointmentsSubstatusChart,
                appointmentsSubstatusChart: state.appointmentsSubstatusChart,

                getAppointmentsStoresChart,
                appointmentsStoresChart: state.appointmentsStoresChart,

                getAppointmentsDetailsChart,
                appointmentsDetailsChart: state.appointmentsDetailsChart,

                getTotalsVisitsDashboard,
                totalVisitsDash: state.totalVisitsDash,

                getVisitsSubstatusChart,
                visitsSubstatusChart: state.visitsSubstatusChart,

                getVisitsDetailsChart,
                visitsDetailsChart: state.visitsDetailsChart,

                getTotalsCallsDashboard,
                totalCallsDash: state.totalCallsDash,

                getClosureTopUsers,
                closureTopUsers: state.closureTopUsers,

                getDrilldownCalls,
                drilldownCalls: state.drilldownCalls,

                getDrilldownRecordings,
                drilldownRecordings: state.drilldownRecordings,

                getDrilldownFunnelSource,
                drilldownFunnelSource: state.drilldownFunnelSource,

                getStatusStoresChart,
                statusStoresChart: state.statusStoresChart,

                getTemperaturesLeadsTable,
                temperaturesLeadsTable: state.temperaturesLeadsTable,

                getTemperaturesAppointmentsTable,
                temperaturesAppointmentsTable:
                    state.temperaturesAppointmentsTable,

                getTemperaturesVisitsTable,
                temperaturesVisitsTable: state.temperaturesVisitsTable,

                getTemperaturesSalesTable,
                temperaturesSalesTable: state.temperaturesSalesTable,

                getMonitoringAgent,
                monitoringAgent: state.monitoringAgent,
                loadingChartsAgents: state.loadingChartsAgents,

                getMonitoringAgentSources,
                monitoringAgentSources: state.monitoringAgentSources,

                getTotalTemperatures,
                totalTemperatures: state.totalTemperatures,

                getTemperaturesFunnelRSIComparative,
                temperaturesFunnelRSIComparative:
                    state.temperaturesFunnelRSIComparative,

                getTemperaturesFunnelAppointmentComparative,
                temperaturesFunnelAppointmentComparative:
                    state.temperaturesFunnelAppointmentComparative,

                getFunnelDatos,
                funnelDatos: state.funnelDatos,

                getReportSales,
                reportSales: state.reportSales,

                getReportResponseTime,
                reportResponseTime: state.reportResponseTime,

                getCaptacionMedios,
                captacionMedios: state.captacionMedios,

                getPendingTasksReport,
                pendingTasksReport: state.pendingTasksReport,

                getTableModels,
                tableModels: state.tableModels,

                getTableSources,
                tableSources: state.tableSources,

                getTableAgentSources,
                tableAgentSources: state.tableAgentSources,

                getTableAgencies,
                tableAgencies: state.tableAgencies,

                getTableLeadsByAgents,
                tableLeadsByAgents: state.tableLeadsByAgents,

                getVisitsReport,
                visitsReport: state.visitsReport,

                getMatrixInvestment,
                matrixInvestment: state.matrixInvestment,

                getMatrixInvestmentCampaign,
                matrixInvestmentCampaign: state.matrixInvestmentCampaign,

                getMatrixInvestmentAdset,
                matrixInvestmentAdset: state.matrixInvestmentAdset,

                getAgentsComparative,
                agentsComparative: state.agentsComparative,

                getAddonsReport,
                addonsReport: state.addonsReport,

                getAgentsCallsPerformance,
                agentsCallsPerformance: state.agentsCallsPerformance,

                getAIReport,
                AIReport: state.AIReport,

                getWarboxTemplateMetrics,
                warboxTemplateMetrics: state.warboxTemplateMetrics,

                getSystemReport,
                systemReport: state.systemReport,

                clearCharts,
                setLoading,
            }}
        >
            {props.children}
        </ChartContext.Provider>
    );
};

export default ChartState;
